import React from "react";
import { IconButton } from '@mui/material';
import useStyles from "../../style/js-style/components/thirdparties/ThirdpartyIdentifiersStyle"
import { PrivilegeEnum } from "../../services/common/RolesUtils";
import ThirdpartyCodeUpdate from './ThirdpartyCodeUpdate';
import EAColorIcon from '../common/EAColorIcon';
import TooltipOnClick from '../common/TooltipOnClick';

function ThirdpartyIdentifiers({
                                 identifiers, size = 3, thirdpartyCode, hasAnyOfPrivilegesOnScopedResource,
                                   onTpCodeChange, tpId
                               }) {
  identifiers = identifiers?.filter(item => item.value || item.value === "");
  const shownIdentifiers = size !== "full" ? identifiers?.slice(0, size) : identifiers;
  const { classes } = useStyles();
  const [isUpdateThirdPartyDialogOpen, setIsUpdateThirdPartyDialogOpen] = React.useState(false);

  const openUpdateThirdPartyPopup = () => {
    setIsUpdateThirdPartyDialogOpen(true);
  };


  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        alignItems: 'flex-start',
      }}
    >
      {shownIdentifiers?.map((item, index) =>
        index === 0 &&
        isUpdateThirdPartyDialogOpen &&
        hasAnyOfPrivilegesOnScopedResource(
          PrivilegeEnum.PRIVILEGE_EDIT_THIRD_PARTY_CODE
        ) ? (
          <ThirdpartyCodeUpdate
            thirdpartyId={tpId}
            tpCode={thirdpartyCode}
            onTpCodeChange={onTpCodeChange}
            handleClose={() => setIsUpdateThirdPartyDialogOpen(false)}
          />
        ) : index === 0 ? (
          <div
            className={classes.thirdPartieCodeWrapper}
            key={index}
            onClick={index === 0 && openUpdateThirdPartyPopup}
          >
            <span className={classes.thirdPartieIdContent}>
              <span className="dt">{`${item.value || '-'}${
                item.type ? ` (${item.type})` : ''
              }`}</span>
            </span>

            {item.icon && (
              <IconButton
                size="small"
                disabled={
                  !hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_EDIT_THIRD_PARTY_CODE)
                }
                onClick={openUpdateThirdPartyPopup}
                sx={{ position: 'absolute', top: '-3px', right: '-30px' }}
              >
                {item.icon}
              </IconButton>
            )}
          </div>
        ) : (
          <TooltipOnClick
            copyValue={item.value || ''}
            children={
              <div
                key={index}
                style={{ display: 'flex', gap: '8px', cursor: 'pointer' }}
              >
              <span className={classes.thirdPartieIdContent}>
                <span className="dt">{`${item.value || ''}${
                  item.type ? ` (${item.type})` : ''
                }`}</span>
              </span>
                <EAColorIcon
                  icon={'content_copy'}
                  svgStyle={{ position: 'relative', top: '2px' }}
                />
              </div>
            }
          />
        )
      )}
    </div>
  );
}

export default ThirdpartyIdentifiers;
